import React, { useMemo, useState } from 'react';
import { useMutation } from '@apollo/client';

import { Feedback as FeedbackComponent } from '@Calix-Commerce/design-system/components';
import { SEND_FEEDBACK } from 'connectors/mutations/feedback';

const FEEDBACK_SESSION_KEY = 'om-feedback-collected';

const Feedback = () => {
  const [rating, setRating] = useState(null);
  const [comment, setComment] = useState('');

  const [sendFeedback] = useMutation(SEND_FEEDBACK, {
    errorPolicy: 'ignore',
  });

  const isFeedbackCollected = useMemo(() => sessionStorage.getItem(FEEDBACK_SESSION_KEY), []);

  const handleFeedbackSubmit = () => {
    sessionStorage.setItem(FEEDBACK_SESSION_KEY, true);

    sendFeedback({
      variables: {
        input: {
          rating,
          comment,
          context: 'OrderManager',
        },
      },
    });
  };

  return isFeedbackCollected ? null : (
    <FeedbackComponent
      rating={rating}
      comment={comment}
      onSubmit={handleFeedbackSubmit}
      onRatingChange={setRating}
      onCommentChange={setComment}
    />
  );
};

export { Feedback };
